import React from 'react'


import { Modal } from 'react-bootstrap'
import { config } from '../Config/config'
import cariobatService from '../Service/cariobatService'
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import ModalSearch from './modalSearch'
import FormKeranjang from './formKeranjang'

export default class listObat extends React.Component {

    constructor() {
        super()
        this.state = {
            List: [],
            showModalCari: false,
            count: 0,
            TotalProduct: 0,
            EstimatePrice: 0,
            filter: {
                page: '1',
                pagesize: '4',

                kategori: localStorage.getItem(config.kategoriObat),
                search: localStorage.getItem(config.searchObat),
                segment: localStorage.getItem(config.segmen),
                hargaMin: localStorage.getItem(config.hargaMin),
                hargaMax: localStorage.getItem(config.hargaMax),

            }
        }
    }

    loadList = async () => {
        const respon = await cariobatService.getAllFilter(this.state.filter)
        const responCount = await cariobatService.countData()

        if (respon.success) {
            let count = 0
            if (responCount.result != undefined) {
                count = responCount.result.count
            }
            this.setState({
                List: respon.result,
                TotalPage: Math.ceil(count / this.state.filter.pagesize)
            })
        }
        console.log(this.state.List)

    }

    componentDidMount() {
        // if (!localStorage.getItem(config.segmen)) {
        //     this.setState({
        //         filter: {
        //             ...this.state.filter,
        //             ["segment"]: "obat bebas"
        //         }
        //     })
        // }
        this.loadList()
    }

    // changeHandler = field => ({ target: { value } }) => {
    //     this.setState({
    //         Model: {
    //             ...this.state.Model,
    //             [field]: value
    //         }
    //     })
    // }


    // saveHandler = async () => {
    //     if (this.handleValidation()) {
    //         if (this.state.Mode == "Ubah") {
    //             const respon = await courierService.EditData(this.state.Model)
    //             if (respon.success) {
    //                 this.loadList()
    //                 this.setState({
    //                     Model: this.courierModel,
    //                     showModal: false
    //                 })
    //             }
    //         }
    //         else {
    //             const respon = await courierService.addData(this.state.Model)
    //             console.log(respon)
    //             if (respon.success) {
    //                 alert("Success Save Data")
    //                 this.loadList()
    //                 this.setState({
    //                     Model: this.courierModel,
    //                     showModal: false
    //                 })

    //             }
    //         }
    //     }
    // }


    filterHandler = field => ({ target: { value } }) => {
        this.setState({
            filter: {
                ...this.state.filter,
                [field]: value
            }
        })
    }

    // handleValidation() {
    //     let fields = this.state.Model
    //     let errors = {}
    //     let formIsValid = true;

    //     if (!fields["name"]) {
    //         formIsValid = false
    //         errors["name"] = "Name cannot be empty"
    //     }

    //     this.setState({ errors: errors })
    //     return formIsValid
    // }

    renderPagination() {
        let item = []
        for (let number = 1; number <= this.state.TotalPage; number++) {
            item.push(
                <PaginationItem key={number} active={number === this.state.filter}>
                    <PaginationLink onClick={() => this.changePageHandler(number)}>
                        {number}
                    </PaginationLink>
                </PaginationItem>
            )
        }
        return (
            <Pagination>{item}</Pagination>
        )
    }

    pageSizeHandler = (size) => {
        this.setState({
            filter: {
                ...this.state.filter,
                ["pagesize"]: size
            }
        }, () => this.loadList())
    }

    changePageHandler = (number) => {
        this.setState({
            filter: {
                ...this.state.filter,
                ["page"]: number
            }
        }, () => this.loadList())
    }

    showModal = () => {
        this.setState({
            showModalCari: true
        })
    }

    cancelModal = () => {
        this.setState({
            showModalCari: false
        })
    }


    incrementTotal = () => {
        this.setState({
            TotalProduct: this.state.TotalProduct + 1,
        })
    }

    decrementTotal = () => {
        if (this.state.TotalProduct >= 1) {
            this.setState({
                TotalProduct: this.state.TotalProduct - 1,
            })
        }

    }

    gantiButton = () => {
        console.log("hehe")
        this.setState({
            displayButton: 'none',
            displayTambah: ''
        })
    }




    render() {
        const { showModalCari, errors, List, TotalProduct, EstimatePrice, displayButton, displayTambah } = this.state
        const { pencarian } = this.props

        return (
            <div>
                {/* {JSON.stringify(this.state.filter)} */}
                <div class="row">
                    <div class="col-10">
                        <h4>Hasil Pencarian : {localStorage.getItem(config.hasilCariObat)} </h4>
                    </div>
                    <div class="col">
                        <button class="btn btn-primary mb-3 float-right" onClick={this.showModal}>Ulangi Pencarian</button>
                    </div>

                </div>
                <div class="row">
                    {
                        List.map(data => {
                            return (
                                <div class="col-6">
                                    <div class="card cardObat">
                                        <div class="card-body">
                                            <div class="row mb-2">
                                                <div class="col-9">
                                                    <h4>{data.nama}</h4>
                                                    <h6>{data.packaging}</h6>
                                                    <h6>Rp {data.hargaMin} - Rp {data.hargaMax}</h6>
                                                    <h5>{data.indikasi}</h5>
                                                </div>
                                                <div class="col-3">
                                                    <img class="gambarObat mb-2" src={data.gambar}></img>
                                                </div>
                                            </div>
                                            <div >
                                                <FormKeranjang/>
                                                {/* <div class="col-9" style={{ display: `${displayButton}` }}>
                                                    <button class="btn btn-primary" onClick={this.gantiButton} >Tambah ke Keranjang</button>
                                                </div>
                                                <div class="col-9 text-center" style={{ display: `${displayTambah}` }}>
                                                    <div class="row">
                                                        <button>+</button>
                                                        <h5>{TotalProduct}</h5>
                                                        <button>-</button>
                                                    </div>
                                                </div>
                                                <div class="col">
                                                    <button class="btn btn-outline-primary float-right">Detail</button>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }

                </div>

                <div class="float-right">
                    {this.renderPagination()}
                </div>


                <div class="jumbotron jumbotron-fluid mt-5" style={{width:"100%"}}>
                    <h3>Produk {TotalProduct} | Estimasi Harga: Rp {EstimatePrice}</h3>
                </div>
                


                <ModalSearch
                    showModalCari={showModalCari}
                    cancelModal={this.cancelModal} />
            </div>
        )
    }
}